<template>
<div :class="_class" v-bind:aria-label="aria_label">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        vertical: {
            type: Boolean,
            default: false,
        },
        aria_label: {
            type: String,
            default: 'default aria label'
        },
    },
    computed: {
        _class: function() {
            let _class = []

            if(this.vertical === true) {
                _class.push('btn-group-vertical')
            }

            if(this.vertical === false) {
                _class.push('btn-group')
            }

            return _class
        }
    },
}
</script>